/* ======== Hooks ========= */
import { useAppTheme } from "@hooks/useAppTheme";

import Icon from "@expo/vector-icons/MaterialCommunityIcons";
import { useAppStore } from "@hooks/useAppStore";
/* ======== Components ========= */
import Box from "@memorang/ui/src/components/Box";
import RenderMarkdown from "@memorang/ui/src/components/MarkdownRenderer";

type Props = {
	features: string[];
};
const FeaturesSection = ({ features }: Props) => {
	const theme = useAppTheme();
	const font = useAppStore((state) => state.app.font);
	return (
		<Box paddingHorizontal={0} gap={8}>
			{features.map((item) => (
				<Box
					display="flex"
					flexDirection="row"
					alignItems="center"
					key={item}
					gap={8}
				>
					<Icon size={24} color={theme.colors.progress.high} name="check" />
					<Box flex={1}>
						<RenderMarkdown variant="explanation" text={item} appFont={font} />
					</Box>
				</Box>
			))}
		</Box>
	);
};
export default FeaturesSection;
